import React from 'react';
import { TypedMemo } from '../../../../common/types';
import { useGetReleaseOverviewQuery } from '../../../../../redux/api/fymAPI';
import { useShowUnlockCards } from './useShowUnlockCards';
import { UnlockCards } from './UnlockCards';

interface ReleaseUnlockCardsProps {
  accountId: number;
  catalogItemUuid: string;
  /** The song is not out and has no release day and no pre-save page. */
  needsReleaseDay?: boolean;
}

/**
 * The unlock cards at the top of Overview and Assets (design: onboarding c5). The setup check comes
 * from `GET /releases/:uuid`, the same cache entry the two tabs read. Other songs send no read.
 */
const ReleaseUnlockCardsComponent: React.FC<ReleaseUnlockCardsProps> = ({
  accountId,
  catalogItemUuid,
  needsReleaseDay = false,
}) => {
  const isFirstRelease = useShowUnlockCards(catalogItemUuid);
  const overview = useGetReleaseOverviewQuery({ accountId, catalogItemUuid }, { skip: !isFirstRelease });
  if (!isFirstRelease) {
    return null;
  }
  return (
    <UnlockCards catalogItemUuid={catalogItemUuid} setup={overview.data?.setup} needsReleaseDay={needsReleaseDay} />
  );
};

export const ReleaseUnlockCards = TypedMemo(ReleaseUnlockCardsComponent);
